import NavBar from '@components/common/navbar'
import Footer from '@components/common/footer'
import FirstFold from '@components/wrapped/first-fold'
import WrappedDescription from '@components/wrapped/wrapped-description'
import WrappedCarousel from '@components/wrapped/wrapped-carousel'
import PersonalizedSection from '@components/wrapped/personalized-section'
import { FastlyImage } from '@components/common/image'
import Button from '@components/atoms/button'
import { NextSeo } from 'next-seo'
import { formatSeoConfig } from '@lib/seo'
import date from '@lib/utils/date.utils'

export const wrappedYear = date().year() - 1

export const wrappedSeo = formatSeoConfig({
  title: `Codingal Wrapped ${wrappedYear} | Your Year in Code, Wrapped`,
  description: `Your front-row seat to Codingal’s ${wrappedYear} highlights — projects built, learning milestones, teacher impact, and what we shipped. Open the Wrapped PDF.`,
  url: 'https://www.codingal.com/wrapped/',
  metaImage: 'https://fastly.codingal.com/images/wrapped/wrapped-og.jpg',
})

export const WRAPPED_PDF_URL =
  'https://codingal.s3.ap-south-1.amazonaws.com/media/blackops/others/Codingal-Wrapped-2025-Year-in-Review-921b.pdf'

export const WRAPPED_YT_URL =
  'https://www.youtube.com/watch?v=F4O0WtzDztE&feature=youtu.be'

const Wrapped = () => {
  return (
    <>
      <NextSeo {...wrappedSeo} />
      <NavBar isSticky />
      <FirstFold />
      <WrappedDescription />
      <WrappedCarousel />
      <PersonalizedSection />
      <div className="container mx-auto mt-12 md:mt-16">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-600 leading-tight mb-10 text-center">
          See you next year.
        </h2>
        <div className="flex bg-orange flex-col items-center gap-4">
          <FastlyImage
            src="images/wrapped/wrapped-loading.png"
            width={1183}
            height={650}
            alt="Wrapped Loading..."
            className="mx-auto"
          />
        </div>
      </div>
      <div className="my-12 md:my-16 mb-20 container mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-600 leading-tight mb-10 text-center">
          The Wrapped Library.
        </h2>
        <a
          href={WRAPPED_PDF_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex mx-auto px-5 md:px-10 my-10"
        >
          <Button size="md" className="w-full sm:w-auto mx-auto">
            View Wrapped {wrappedYear}
          </Button>
        </a>
      </div>
      <Footer />
    </>
  )
}

// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default Wrapped
